import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[msSliderContainer]',
})
export class SliderContainerDirective {
    element = inject(ElementRef);
}
